import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GetClientAll } from '../../../store/constants'

export default () => async (dispatch, getState) => {
    
    const Authorization = UserToken;        
    
    const url = ApiUrl2 + '/user-client-list';
    var paramBody = {
        "query":{
            "search":"",
            "page":1,
            "page-size":1000,
            "order-by":1,
            "order":"ASC"
        }
    };
    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };  

    const response = await fetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('query-result');
        data = data.get('data');
    }
    dispatch({ type: GetClientAll, data: fromJS(data) });
};